import { combineReducers } from "redux";

import GetSuccessSpeaks from "../features/website/Slice";

const website = combineReducers({
  GetSuccessSpeaks: GetSuccessSpeaks,
});

export default website;
